var $carousel = $('.integrate-instagram-like-pagedots');
const MAX_DOTS = 5,
  DOT_WINDOW = 3,
  DOT_WIDTH_IN_PX = 17;

var settings = [];

function initializeCarousel() {
  if ($carousel.data('flickity')) {
    settings = {
      selectedDot: 0,
      numberOfDots: 0,
      holderOffset: 2,
      dotWindowMin: 0,
      dotWindowMax: DOT_WINDOW - 1
    };

    var flkty = $carousel.data('flickity');

    function updateDots() {
      const carouselSettings = settings;

      carouselSettings.numberOfDots = flkty.pageDots?.dots?.length;
      if (carouselSettings.numberOfDots > 5) {
        flkty.pageDots.holder.classList.add('flickity-page-dots--overflow');
      } else {
        flkty.pageDots.holder.classList.remove('flickity-page-dots--overflow');
      }

      carouselSettings.selectedDot = flkty.selectedIndex;

      if (carouselSettings.selectedDot > carouselSettings.dotWindowMax) {
        carouselSettings.dotWindowMax = carouselSettings.selectedDot;
        carouselSettings.dotWindowMin = carouselSettings.dotWindowMax - DOT_WINDOW + 1;
      }
      if (carouselSettings.selectedDot < carouselSettings.dotWindowMin) {
        carouselSettings.dotWindowMin = carouselSettings.selectedDot;
        carouselSettings.dotWindowMax = carouselSettings.dotWindowMin + DOT_WINDOW - 1;
      }

      for (let j = 0; j < carouselSettings.numberOfDots; j++) {
        const dot = flkty.pageDots.dots[j];
        let newDotClass = '';

        if (j == carouselSettings.dotWindowMin - 2) {
          newDotClass = 'dot--prev-prev';
        } else if (j == carouselSettings.dotWindowMin - 1) {
          newDotClass = 'dot--prev';
        } else if (j >= carouselSettings.dotWindowMin && j <= carouselSettings.dotWindowMax) {
          newDotClass = 'dot';
        } else if (j == carouselSettings.dotWindowMax + 1) {
          newDotClass = 'dot--next';
        } else if (j == carouselSettings.dotWindowMax + 2) {
          newDotClass = 'dot--next-next';
        } else {
          newDotClass = 'dot--prev-prev'; //dot--offscreen
        }
        if (dot.getAttribute('data-dot') !== newDotClass) {
          dot.setAttribute('data-dot', newDotClass);
        }
      }

      let newOffset = carouselSettings.dotWindowMin - 2;
      if (carouselSettings.numberOfDots <= MAX_DOTS) {
        newOffset = 0;
      }
      if (newOffset !== carouselSettings.holderOffset) {
        flkty.pageDots.holder.style.textIndent = `${newOffset * -DOT_WIDTH_IN_PX}px`;
        carouselSettings.holderOffset = newOffset;
      }
    }
    
    var flickityPageDotsCount = flkty?.pageDots?.dots?.length;
    if (flickityPageDotsCount > MAX_DOTS){
      updateDots(); // Calling updateDots initially
    }

    /* Showing Page Dots once pagedots updated */
    $carousel.on('select.flickity', updateDots); 
    if (window.matchMedia("(max-width: 980px)").matches) {
      $("ol.flickity-page-dots").each(function() {
        this.style.setProperty('display', 'block', 'important');
      });
    }
    
    clearInterval(initializationCheck); // Clearing the interval once Flickity is initialized
  }
}
var initializationCheck = setInterval(initializeCarousel, 100); // Checking every 100ms if Flickity is initialized

$carousel.flickity(); // Initializing Flickity
